module App.Interfaces {
    export interface IDiscount {
        code: string;
        description: string;
    }
}